import styles from "./style.module.scss";
import classNames from "classnames";
import { Tooltip, Typography } from "antd";
import { useNavigate } from "react-router";
import { DatasetStatus } from "../../../../types";

interface DatasetStatusProps {
  status: DatasetStatus;
  datasetId: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}
export default function DatasetStatusBadge({
  status,
  datasetId,
  onClick,
  icon,
}: DatasetStatusProps) {
  const getStyleByDatasetStatus: Record<DatasetStatus, string> = {
    [DatasetStatus.READY]: styles.greenButton,
    [DatasetStatus.DRAFT]: styles.greenButton,
    [DatasetStatus.INDEXING]: styles.blueButton,
    [DatasetStatus.READ_ONLY]: styles.blueButton,
    [DatasetStatus.PARTIAL_INDEX]: styles.orangeButton,
    [DatasetStatus.ERROR]: styles.errorButton,
  };
  const { Link } = Typography;
  const navigate = useNavigate();
  return (
    <div
      className={classNames(
        getStyleByDatasetStatus[status],
        styles.statusButton,
      )}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <Tooltip
        title={
          status === DatasetStatus.READ_ONLY && (
            <div className={styles.tooltipContent} onClick={onClick}>
              You can see more details in the{" "}
              <Link
                onClick={() =>
                  navigate(`/task-manager?dataset_id=${datasetId}`)
                }
              >
                Task Manager
              </Link>{" "}
              table
            </div>
          )
        }
      >
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          {status.toLowerCase()}
          {icon}
        </div>
      </Tooltip>
    </div>
  );
}
